import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getSettings, defaultDb } from '../db/indexedDb';
import { formatDaysLeft } from '../config/goalPlanner';

export function SrsSettingsSection() {
  const navigate = useNavigate();
  const [goalSummary, setGoalSummary] = useState<{
    hasGoal: boolean;
    targetDate?: number;
    daysLeft?: string;
    dailyMinutes?: number;
  }>({ hasGoal: false });

  useEffect(() => {
    (async () => {
      const settings = await getSettings('app', defaultDb);
      if (settings?.studyGoal) {
        const goal = settings.studyGoal;
        setGoalSummary({
          hasGoal: true,
          targetDate: goal.targetDate,
          daysLeft: formatDaysLeft(goal.targetDate),
        });
      }
    })();
  }, []);

  return (
    <section className="section">
      <h2 className="section-title">学习目标</h2>

      <div 
        className="card" 
        style={{ marginBottom: '16px', cursor: 'pointer' }}
        onClick={() => navigate('/goal')}
      >
        <div className="card-body stack">
          {goalSummary.hasGoal ? (
            <>
              <div className="flex justify-between items-center">
                <h3>🎯 当前目标</h3>
                <span style={{ color: 'var(--accent-cyan)', fontWeight: 700 }}>编辑 →</span>
              </div>
              <p>
                目标日期: {goalSummary.targetDate ? new Date(goalSummary.targetDate).toLocaleDateString() : '-'}
              </p>
              <p className="caption">
                还剩 {goalSummary.daysLeft}
              </p>
            </>
          ) : (
            <>
              <div className="flex justify-between items-center">
                <h3>📋 设定学习目标</h3>
                <span style={{ color: 'var(--accent-cyan)', fontWeight: 700 }}>开始 →</span>
              </div>
              <p className="caption">
                规划学习进度，设定目标日期和每日任务
              </p>
            </>
          )}
        </div>
      </div>
    </section>
  );
}
